import React from "react";

const ListNodes = ({ nodes }) =>
  nodes.map((node, nodeIx) => (
    <div className={`w-100 ${nodeIx ? "pt3" : ""}`} key={nodeIx}>
      {node}
    </div>
  ));

export default ListNodes;
